// extracted by mini-css-extract-plugin
export default {"buttonWrapper":"iO0TJyTaPyynK997kogq"};